import axios from 'axios';

import { AI_API_ENDPOINT } from 'constants/api';

const aiApi = axios.create({
  baseURL: AI_API_ENDPOINT,
});

export default aiApi;
